import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout")(
    {
        component: () => <FeedLayout />,
        loader: ({ context: { t } }) => ({
            breadcrumb: t("pages.tool.structure.feed.title"),
        }),
    }
);

function FeedLayout() {
    return <Outlet />;
}
